import { render } from "./StaffManagement.vue?vue&type=template&id=07562a50&scoped=true"
import script from "./StaffManagement.vue?vue&type=script&lang=js"
export * from "./StaffManagement.vue?vue&type=script&lang=js"

import "./StaffManagement.vue?vue&type=style&index=0&id=07562a50&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07562a50"]])

export default __exports__